module.exports = "<div class=blockquote compile=::content.$$html compile-term=true></div>";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/practicalExample/js/quote/quote.html
// module id = 1127
// module chunks = 0